const Union = require('tagged-union');

export default new Union(['NotStarted',
    'Fetching',
    'Complete',
    'Error']);



// WEBPACK FOOTER //
// ./src/data/photos-request.js